import { SET_USER_COMPANIES } from '@web-shared/consts/action-types';

import { fetchUserCompanies } from '../../api/companies';
import { AppThunk } from '../types';

export const getUserCompanies = (): AppThunk<Promise<void>> => async (dispatch) => {
  const companies = await fetchUserCompanies({ params: null });
  dispatch({
    type: SET_USER_COMPANIES,
    payload: { current: null, companies: companies }
  });
};
